import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import NotesItem from "./NotesItem";
import { canSeeCaseNotesTab, filterNotesByPermission } from "../../../../lib/notesPermissions";
import { caseNotesForViewer, omitDeletedRecords } from "../../../../lib/noteDelete";

import classes from './NotesDetails.module.css'

const NotesDetails = ({ showDeleted }) => {
    const activeCase = useSelector(state => state.case.activeCase)         
    const searchedNotesResult = useSelector(state => state.notes.filterResult)
    const editPermissions = useSelector(state => state.permissions.editPermissions)
    const userPermissions = useSelector(state => state.user.user?.permissions)
    const canSeeNotesTab = useMemo(
        () => canSeeCaseNotesTab(userPermissions, editPermissions, activeCase),
        [userPermissions, editPermissions, activeCase]
    )
    const permittedFilterResult = useMemo(
        () => caseNotesForViewer(filterNotesByPermission(searchedNotesResult, editPermissions), canSeeNotesTab),
        [searchedNotesResult, editPermissions, canSeeNotesTab]
    )
    const visibleFilterResult = useMemo(() => {
        if (!Array.isArray(permittedFilterResult) || showDeleted) {
            return permittedFilterResult
        }
        return omitDeletedRecords(permittedFilterResult)
    }, [permittedFilterResult, showDeleted])

    const [data, setData] = useState(null)

    useEffect(() => {
        if (activeCase) {
            
            let arr = [...caseNotesForViewer(filterNotesByPermission(activeCase.notes || [], editPermissions), canSeeNotesTab)].sort(function(x, y) {
                return new Date(y.created_at) - new Date(x.created_at)
            });
            
            setData(arr)
        }
    }, [activeCase, editPermissions, canSeeNotesTab])

    const visibleData = useMemo(() => {
        if (!Array.isArray(data) || showDeleted) {
            return data
        }
        return omitDeletedRecords(data)
    }, [data, showDeleted])

    return <div className={classes.container}>
        <table className="table-plain table-border-radius-8">
            <thead>
                <tr>
                    <th>Date added</th>
                    <th>Added by</th>
                    <th>Note type</th>
                    <th>Notes</th>
                    <th>Type</th>
                    <th>Priority</th>
                    <th>Assigned to</th>
                    <th>Action required</th>
                    <th>Due date</th>
                    <th>Resolve</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {!searchedNotesResult && visibleData && visibleData.map(item => (
                    <NotesItem key={item.id} itemData={item} caseData={activeCase}/>
                ))}
                {searchedNotesResult && visibleFilterResult && visibleFilterResult.length > 0 && visibleFilterResult.map(item => (
                    <NotesItem key={item.id} itemData={item} caseData={activeCase}/>
                ))}
                {searchedNotesResult && visibleFilterResult && visibleFilterResult.length == 0 && <tr>
                    <td colSpan='11'>No results found!</td>
                </tr>}
            </tbody>
        </table>
    </div>
}

export default NotesDetails
